(function () {
  'use strict';

  var isMainCatalog = /^\/collections\/all\/?$/.test(window.location.pathname);
  var catalogUrl = new URL(window.location.href);

  if (isMainCatalog && !catalogUrl.searchParams.has('sort_by')) {
    catalogUrl.searchParams.set('sort_by', 'best-selling');
    window.location.replace(catalogUrl.toString());
    return;
  }

  function track(eventName, label) {
    if (!Array.isArray(window.dataLayer)) {
      return;
    }

    window.dataLayer.push({
      event: eventName,
      cda_label: label || ''
    });
  }

  function buildFinderUrl(baseUrl, age, playType) {
    var tags = [age, playType].filter(Boolean);
    var destination = new URL(baseUrl, window.location.origin);

    destination.searchParams.set('type', 'product');
    destination.searchParams.set('q', tags.map(function (tag) {
      return 'tag:' + tag;
    }).join(' AND '));
    destination.searchParams.set('sort_by', 'best-selling');

    return destination.toString();
  }

  function enhanceSlideshows(scope) {
    if (!window.Flickity) {
      return;
    }

    (scope || document).querySelectorAll('[data-section-type="slideshow"]').forEach(function (section) {
      var slideshow = section.querySelector('.slideshow');
      var toggle = section.querySelector('[data-cda-slideshow-toggle]');
      var instance = slideshow ? window.Flickity.data(slideshow) : null;

      if (!instance || section.hasAttribute('data-cda-slideshow-ready')) {
        return;
      }

      section.setAttribute('data-cda-slideshow-ready', 'true');

      var dots = section.querySelectorAll('.flickity-page-dots .dot');
      var updateDots = function () {
        dots.forEach(function (dot, index) {
          dot.setAttribute('role', 'button');
          dot.setAttribute('tabindex', '0');
          dot.setAttribute('aria-label', 'Ir para o banner ' + (index + 1));
          dot.setAttribute('aria-current', index === instance.selectedIndex ? 'true' : 'false');
        });
      };

      dots.forEach(function (dot) {
        dot.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            dot.click();
          }
        });
      });

      instance.on('select', updateDots);
      updateDots();

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var paused = reducedMotion;

      function updateToggle() {
        if (!toggle) {
          return;
        }

        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        var label = toggle.querySelector('[data-cda-slideshow-toggle-label]');
        if (label) {
          label.textContent = paused ? 'Retomar banners' : 'Pausar banners';
        }
      }

      if (paused) {
        instance.stopPlayer();
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          paused = !paused;
          if (paused) {
            instance.stopPlayer();
          } else {
            instance.playPlayer();
          }
          updateToggle();
        });
      }

      updateToggle();
    });
  }

  function ensureCheckoutFallback() {
    if (!/\/cart\/?$/.test(window.location.pathname)) {
      return;
    }

    var fallbackButtons = document.querySelectorAll('[name="checkout"]:not(.ymp_elem_mainBtn)');

    if (!fallbackButtons.length) {
      return;
    }

    function syncCheckoutButtons() {
      var yampiButton = document.querySelector('.ymp_elem_mainBtn');
      var yampiReady = yampiButton && yampiButton.offsetParent !== null;

      fallbackButtons.forEach(function (button) {
        if (yampiReady) {
          button.style.removeProperty('display');
          button.removeAttribute('data-cda-checkout-fallback');
          return;
        }

        button.style.setProperty('display', 'block', 'important');
        button.setAttribute('data-cda-checkout-fallback', 'true');
      });
    }

    window.setTimeout(syncCheckoutButtons, 3500);

    var checkoutObserver = new MutationObserver(function () {
      if (document.querySelector('.ymp_elem_mainBtn')) {
        syncCheckoutButtons();
        checkoutObserver.disconnect();
      }
    });

    checkoutObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      checkoutObserver.disconnect();
    }, 15000);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cda-play-finder]');

    if (!form) {
      return;
    }

    event.preventDefault();

    var age = form.querySelector('[name="idade"]');
    var playType = form.querySelector('[name="brincadeira"]');
    var ageValue = age ? age.value : '';
    var playValue = playType ? playType.value : '';
    var destination = buildFinderUrl(form.action, ageValue, playValue);

    track('cda_finder_submit', [ageValue, playValue].filter(Boolean).join(' | '));
    window.location.assign(destination);
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cda-analytics]');

    if (!link) {
      return;
    }

    track(link.getAttribute('data-cda-analytics'), link.getAttribute('data-cda-label'));
  });

  document.addEventListener('DOMContentLoaded', function () {
    ensureCheckoutFallback();
    enhanceSlideshows(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    enhanceSlideshows(event.target);
  });
})();
